// extracted by extract-css-chunks-webpack-plugin
module.exports = {"root":"root_Rt07S","defaultRoot":"defaultRoot_WWw0G","input":"input_BcKH1","action":"action_AvUQD","button":"button_EYoAE"};